import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import "bootstrap/dist/css/bootstrap.min.css";

// ✅ Validation Schema
const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
});

const ForgotPassword = () => {
  const [message, setMessage] = useState({ text: "", type: "" });

  const handleSubmit = async (values, { setSubmitting }) => {
    setMessage({ text: "", type: "" });

    try {
      await new Promise((resolve) => setTimeout(resolve, 1500)); // Simulated API delay

      setMessage({
        text: "Password reset link has been sent to your email.",
        type: "success",
      });
    } catch (error) {
      setMessage({
        text: "Something went wrong. Please try again.",
        type: "danger",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
    // className="card p-4 shadow-lg"
    style={{ maxWidth: "450px", width: "100%" }}
  >
    <h3 className="text-center mb-2" id="forgot-password-title">
      Forgot Password
    </h3>
    <p className="text-center text-muted" id="forgot-password-subtitle">
      Enter your email to receive a password reset link.
    </p>

    {message.text && (
      <div
        className={`alert alert-${message.type}`}
        id={`forgot-password-message-${message.type}`}
      >
        {message.text}
      </div>
    )}

    <Formik
      initialValues={{ email: "" }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form id="forgot-password-form">
          {/* Email Field */}
          <div className="mb-3">
            <label htmlFor="forgot-password-email" className="form-label">
              Email Address *
            </label>
            <Field
              type="email"
              name="email"
              id="forgot-password-email"
              className="form-control"
              placeholder="Enter your email"
            />
            <ErrorMessage
              name="email"
              component="small"
              className="text-danger"
              id="error-forgot-password-email"
            />
          </div>

          {/* Submit Button */}
          <div className="d-grid mb-3">
            <button
              type="submit"
              className="btn btn-primary"
              id="forgot-password-submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Send Reset Link"}
            </button>
          </div>
        </Form>
      )}
    </Formik>

    {/* Back to Login Link */}
    <div className="text-center">
      <Link
        to="/"
        className="text-decoration-none"
        id="forgot-password-back-to-login"
      >
        Back to Login
      </Link>
    </div>
  </div>
  );
};

export default ForgotPassword;
